import React from 'react';
import { Box, Heading, Text } from 'grommet';
import { useRouteError } from 'react-router-dom';
import { ErrorMessages } from '../constants';

export const ErrorPage = ({ message }) => {
    const error = useRouteError();

    return (
        <Box pad="large" align="center" justify="center" fill>
            <Heading level="2">Oops!</Heading>
            <Text>{message || ErrorMessages.default}</Text>
            {error && (
                <Text color="status-error">
                    {error?.statusText || error?.message}
                </Text>
            )}
        </Box>
    );
};
